import { useTranslation } from 'react-i18next';
import AmenitiesFilter from './AmenitiesFilter';
import LandLordFilter from './LandlordFilter';
import BuildingsFilter from './BuildingsFilter';
import PossessionFilterList from './PossessionFilter';
import CeilingHeightFilter from './CeilingHeightFilter';
import KeywordFilter from './KeywordFilter';
import SpaceConditionsFilter from './SpaceConditionsFilter';
import SubmarketFilter from './SubmarketFilter';
import TermsFilter from './TermsFilter';
import SizeFilters from './SizeFilter';
import FirstToMarketFilter from './FirstToMarketFilter';
import LeaseTypeFilter from './LeaseTypeFilter/LeaseTypeFilter';
import PriceFilter from './PriceFilter';
import AccordionFilterGroup from './AccordionFilterGroup';
import s from './Filters.module.less';

const ListingSearchFilters = () => {
  const { t } = useTranslation('filters');
  return (
    <ul className={s.filterListContainer} data-testid="listing-search-filters">
      <li>
        <FirstToMarketFilter />
      </li>
      <li className={s.filterListItemContainer}>
        <SizeFilters />
      </li>
      <li className={s.filterListItemContainer}>
        <PriceFilter />
      </li>
      <AccordionFilterGroup title={t('submarket.title')}>
        <SubmarketFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('buildings.title')}>
        <BuildingsFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('landlord.title')}>
        <LandLordFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('leaseType.title')}>
        <LeaseTypeFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('term.title')}>
        <TermsFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('availability.title')}>
        <PossessionFilterList />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('spaceCondition.shortTitle')}>
        <SpaceConditionsFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('ceilingHeight.title')}>
        <CeilingHeightFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('amenities.title')}>
        <AmenitiesFilter />
      </AccordionFilterGroup>
      <AccordionFilterGroup title={t('keywords.title')}>
        <KeywordFilter />
      </AccordionFilterGroup>
    </ul>
  );
};

export default ListingSearchFilters;
